import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import createPersistedState from "vuex-persistedstate"; // vuex持久化


export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
    // 通用的存储数据 不预先保留 变量名称
    setData: function (state, data) {
      state[data.key] = data.value;
    },
  },
  actions: {
  },
  modules: {
  },
  plugins: [
    createPersistedState({
      key: "chat"
    })
  ],
})
